import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  evaluateCampaignFailed,
  evaluateCampaignSuccess,
  evaluateCampaignStart,
} from "../redux/evaluateCampaign";

import { toast } from "react-toastify";
import { evaluateCampaignApi } from "core/http/service/evaluation";

function* evaluateCampaignWork(
  action: ReturnType<typeof evaluateCampaignStart>
) {
  try {
    const { callback, ...rest } = action.payload;

    const res = yield call(evaluateCampaignApi, rest);
    yield put({
      type: evaluateCampaignSuccess.type,
      payload: {
        data: res.data,
      },
    });

    toast.success("Đánh giá các CV thành công!");

    if (callback) {
      callback();
    }
  } catch (error: any) {
    yield put({
      type: evaluateCampaignFailed.type,
    });

    toast.error(error?.response?.data?.message || "Đánh giá các CV thất bại!");
  }
}

function* watchEvaluateCampaign() {
  yield takeLatest(evaluateCampaignStart.type, evaluateCampaignWork);
}

export default function* evaluateCampaignSaga() {
  yield all([watchEvaluateCampaign()]);
}
